import { useRoute } from "wouter";

import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { DealerChassisResultsRoute } from "../navigation/DealerRoutes";
import {
  TireSize,
  VehicleColourCode,
  VehicleHasMappedParts,
} from "./useGetVehicleInfoByVehicleKeys";

export const useGetVehicleInfoByChassis = (): ModifiedSWRResponse<
  FetcherResult<VehicleInfoByChassisPayload>,
  VehicleInfoByChassisPayload
> => {
  const [isChassisRoute, params] = useRoute(DealerChassisResultsRoute);

  const result = useSwrGet<VehicleInfoByChassisPayload>(
    isChassisRoute
      ? "/retailSiteWebService/vehicle/getVehicleInfoByVehicleChassis.php"
      : null,
    {
      dealerId: params?.dealerId ?? "",
      vehicleChassis: params?.vehicleChassis ?? "",
    }
  );

  return result;
};

export type VehicleInfoByChassisPayload = {
  vehicleColourCodes: VehicleColourCode[];
  vehicleFullTireSizeInfo: TireSize[];
  vehicleHasMappedParts: VehicleHasMappedParts;
  vehicleId: string;
  vehicleOriginalTiresize: TireSize | null;
};
